<template>
  <Slider
    v-model="sliderYears"
    :min="minYear"
    :max="maxYear"
    tooltipPosition="bottom"
  ></Slider>
</template>

<script setup>
import Slider from "@vueform/slider";

const props = defineProps({
  minYear: {
    type: Number,
    default: 2014,
  },
    maxYear: {
        type: Number,
        default: 2020,
    },
});
const emit = defineEmits(["update:sliderYears"]);
const sliderYears = ref([props.minYear, props.maxYear]);

watch(
  sliderYears,
  (newVal) => {
    emit("update:sliderYears", newVal);
  },
  { deep: true }
);

</script>

<style src="@vueform/slider/themes/default.css"></style>
<style>
:root {
  --slider-tooltip-bg: #262e6a;
  --slider-bg: #7882cf;
  --slider-connect-bg: #000;
  --slider-height: 2px;
  --slider-handle-width: 8px;
  --slider-handle-height: 8px;
  --slider-tooltip-arrow-size: 0px;
  --slider-tooltip-distance: 0px;
  --slider-handle-radius: 0px;
}

.slider-handle {
  transform: rotate(45deg);
}
.slider-tooltip {
  transform: rotate(-45deg) !important;
}
</style>